import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class NoMonthlyData extends Component {

  render() {
    const {t} = this.props;
    return (
      <span>
        {
          // ローディング判定
          this.props.isScore ? (
            ''
          ) : // データ取得判定
          (
              <Alert>
                <p>{t("Message.NoMonthlyReport")}</p>
              </Alert>
          )
        }
      </span>
    );
  }
}

export default withTranslation()(NoMonthlyData);



// WEBPACK FOOTER //
// ./src/component/MonthlyReport/NoMonthlyData.js